module.exports = __webpack_public_path__ + "img/zcl.bce69aea.svg";